import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Get in touch`}</p>
    <p><a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1rC8UNQeYPhKFu70WaNsOV3mzqQSlN1eY/view?usp=sharing"
      }}>{`My Resume`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "mailto:dubeyvinay529@gmail.com"
      }}>{`dubeyvinay529@gmail.com`}</a></p>
    <p>{` `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/vinay-dubey-09a947108"
      }}>{`Find me on LinkedIn`}</a>{`.`}</p>
    <p>{` `}<a parentName="p" {...{
        "href": "https://github.com/VinayDubey08"
      }}>{`Find me on GitHub`}</a>{`.`}</p>
    <p>{`Contact no :- +91 8285380207`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      